import {forwardRef} from 'react'
import {KTIcon} from '../../../_metronic/helpers'

export const CustomInputDatePicker = forwardRef<any, any>(({value, onClick, className}, ref) => (
  <button className={className} onClick={onClick} ref={ref}>
    <KTIcon iconName='calendar' className='fs-4' /> {value}
  </button>
))
